import React, { useState, useEffect, Fragment } from "react";
import Navbar from "../partials/Navbar";
import { Link, withRouter } from "react-router-dom";
import Sidebar from "../partials/Sidebar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faList } from "@fortawesome/free-solid-svg-icons/faList";
import ReactDatatable from '@mkikets/react-datatable';
import PropTypes from "prop-types";
import { connect } from "react-redux";
import axios from "axios";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import PairAddModal from "../partials/PairAddModal";
import PairUpdateModal from "../partials/PairUpdateModal";
import { toast, ToastContainer } from "react-toastify";
import Moment from 'moment';
import $ from 'jquery';
import * as myConstList from "../../actions/baseUrl";
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css

const baseUrl = myConstList.baseUrl;

function Pair(props) {
    const [state, setState] = useState({ box1: 1, selected: 0 });
    const [records, setRecords] = useState([]);
    const [tempRecords, setTempRecords] = useState([]);
    const [cryptoList, setCryptoList] = useState([]);
    const [secondCryptoList, setSecondCryptoList] = useState([]);
    const [currentRecord, setCurrentRecord] = useState({
        id: '',
        coin_first_id: '',
        coin_second_id: ''
    });

    const [stateType, setStateType] = useState([
        { name: "All", value: 0, status: 1 },
       // { name: "USDT", value: 7, status: 0 },
        { name: "USDC", value: 7, status: 0 },
        { name: "BTC", value: 4, status: 0 },
        { name: "BNB", value: 1, status: 0 }]);

    const listCount = () => {
        var indents = [];
        for (var i = 1; i <= records.length; i++) {
            indents.push(<option value={i} key={i}> {i} </option>);
        }
        return indents

    };

    const onChange = (e, t, i) => {
        // let tempRecord = [...records]
        //  console.log(e.target.value, " ", i);
        // let preRecord = records.filter((val) => val.pair_order == e.target.value)
        //  console.log(preRecord);
        // const value = e.target.value;
        //if (preRecord.length == 0) {

        axios.post(baseUrl + "/api/pair-data-order-update", { id: t.id, pair_order: parseInt(e.target.value) })
            .then(res => {
                console.log(res)
                if (res.data.status) {
                    //  t.pair_order = e.target.value;                     
                    // tempRecord[i].pair_order = value;
                    //setRecords(tempRecord);
                    toast("Position changed successfully.", {
                        position: toast.POSITION.TOP_CENTER,
                    })
                    setTimeout(() => {
                        window.location.reload();
                    }, 1000)
                }
            }).catch((e) => {
                console.log(e);
            });
        // } else {
        //     toast("Position already in use.", {
        //         position: toast.POSITION.TOP_CENTER,
        //     })
        // }
    }

    const columns = [
        {
            key: "id",
            text: "#",
            className: "id",
            align: "left",
            sortable: true,
            cell: (row, index) => index + 1
        },
        {
            key: "name1",
            text: "Currency Pair Box",
            className: "name",
            align: "left",
            sortable: true,
            cell: record => {
                return (
                    <>
                        <span>{record.name1} /</span>
                        <span>{record.name2}</span>
                    </>
                )
            }
        },
        // {
        //     key: "minNotional",
        //     text: "Minimum Value",
        //     className: "id",
        //     align: "left",
        //     sortable: true

        // },
        {
            key: "order",
            text: "Order",
            className: "date",
            align: "left",
            sortable: true,
            cell: (record, index) => {
                return (

                    <>
                        <select
                            className="form-control"
                            id="box1"
                            value={record.pair_order}
                            onChange={(e) => onChange(e, record, index)}
                        >
                            <option value="null">0</option>
                            {
                                listCount()
                            }

                        </select>
                    </>

                );
            }
        },
        {
            key: "created",
            text: "Date",
            className: "date",
            align: "left",
            sortable: true,
            cell: (record, i) => {
                return (
                    <Fragment key={i}>
                        {Moment(record.created).format('lll')}
                    </Fragment>
                );
            }
        },
        {
            key: "action",
            text: "Orders",
            className: "action",
            width: 100,
            align: "left",
            sortable: false,
            cell: record => {
                return (
                    <Fragment>
                        <div>
                        <Link
                            className="btn btn-danger btn-sm mr-2"
                            to={`/buy-order/${record.name1}/${record.name2}`}
                        >
                            BUY
                        </Link>
                        <Link
                            className="btn btn-warning btn-sm"
                            to={`/sell-order/${record.name1}/${record.name2}`}
                        >
                            SELL
                        </Link>
                        </div>
                    </Fragment>
                );
            }
        },
        {
            key: "action",
            text: "Action",
            className: "action",
            width: 100,
            align: "left",
            sortable: false,
            cell: record => {
                return (
                    <Fragment>
                        <button
                            className="btn btn-danger btn-sm"
                            onClick={() => deleteRecordMgs(record)}
                            disabled={record.is_open === 1 ? true : false}>
                            <i className="fa fa-trash"></i>
                        </button>
                    </Fragment>
                );
            }
        }
    ];

    const config = {
        page_size: 10,
        length_menu: [10, 20, 50],
        filename: "Pair",
        no_data_text: 'No user found!',
        button: {
            print: true,
            csv: true
        },
        language: {
            length_menu: "Show _MENU_ result per page",
            filter: "Filter in records...",
            info: "Showing _START_ to _END_ of _TOTAL_ records",
            pagination: {
                first: "First",
                previous: "Previous",
                next: "Next",
                last: "Last"
            }
        },
        show_length_menu: true,
        show_filter: true,
        show_pagination: true,
        show_info: true,
    };

    const dataChange = () => {
        let allData = [];
        if (state.selected != 0) {
            tempRecords.map((val) => {
                if (state.selected == val.coin_second_id) {
                    // console.log(val);
                    allData.push(val)
                }
            })
            setRecords(allData)
        } else {
            let allData = [...tempRecords];
            setRecords(allData)
        }


    }

    useEffect(() => {
        // Check user permissions here and handle redirection if needed
        getData();
    }, []);

    useEffect(() => {
        // Check user permissions here and handle redirection if needed
        dataChange();
    }, [stateType]);



    useEffect(() => {
        const user = (localStorage.getItem('dbiAdminDetail')) ? JSON.parse(localStorage.getItem('dbiAdminDetail')) : props.auth.user
        console.log("local user => ", user);
        if (user.cryptoCurrency !== undefined && user.cryptoCurrency !== 1) {
            props.history.push("/dashboard");
        }
    }, []);

    useEffect(() => {
        if (props.pairdata !== undefined
            && props.pairdata.pair !== undefined
            && props.pairdata.pair.data !== undefined
            && props.pairdata.pair.data.message !== undefined) {
            if (props.pairdata.pair.data.success) {
                hideModals();
                toast(props.pairdata.pair.data.message, {
                    position: toast.POSITION.TOP_CENTER
                });
                getData();
            } else {
                toast(props.pairdata.pair.data.message, {
                    position: toast.POSITION.TOP_CENTER
                });
            }
        }
    }, [props.pairdata]);

    const getData = () => {
        let typeArray = [];
        typeArray = stateType
            .filter(val => val.status)
            .map(val => val.value);

        if (!typeArray.length) {
            stateType.map((val) => {
                typeArray.push(val.value)

            })
        }
        axios
            .post(baseUrl + "/api/pair-data", { coinId: typeArray })
            .then(res => {
                //  console.log(res.data);
                setRecords(res.data);
                setTempRecords(res.data)
            })
            .catch();

        axios
            .get(baseUrl + "/api/crypto-data")
            .then(res => {
                setCryptoList(res.data);
            })
            .catch();

        axios
            .get(baseUrl + "/api/crypto-data-by-tab")
            .then(res => {
                setSecondCryptoList(res.data);
            })
            .catch();
    }

    const editRecord = (record) => {
        setCurrentRecord({
            id: record.id,
            coin_first_id: record.coin_first_id,
            coin_second_id: record.coin_second_id,
        });
    }

    const deleteRecordMgs = (record) => {
        confirmAlert({
            title: 'Confirm to submit',
            message: 'Really want to delete this pair?',
            buttons: [
                {
                    label: 'Yes',
                    onClick: () => deleteRecord(record)
                },
                {
                    label: 'No'
                }
            ]
        });
    }

    const deleteRecord = (record) => {
        axios
            .post(baseUrl + "/api/pair-delete", { _id: record.id })
            .then(res => {
                if (res.status === 200) {
                    toast(res.data.message, {
                        position: toast.POSITION.TOP_CENTER,
                    })
                }
            })
            .catch();
        getData();
    }

    const pageChange = (pageData) => {
        console.log("OnPageChange", pageData);
    }

    const hideModals = () => {
        $('#add-user-modal').modal('hide');
        $('#update-user-modal').modal('hide');
    }

    const typeChange = (val, i) => {
        console.log(val);
        val.status = (val.status) ? 0 : 1;
        let newValue = { ...val }
        //(val.status) ? 0 : 1;
        const updatedItems = stateType.map((item, index) => {

            // index === i ?  newValue  : item

            item.status = (index === i) ? 1 : 0
            return item
        }
        );
        console.log(updatedItems);
        setStateType(updatedItems)
        setState({ ...state, selected: val.value })

    }

    return (
        <div>
            <Navbar />
            <div className="d-flex" id="wrapper">
                <Sidebar />
                <PairAddModal cryptoList={cryptoList} secondCryptoList={secondCryptoList} />
                <PairUpdateModal record={currentRecord} cryptoList={cryptoList} secondCryptoList={secondCryptoList} />
                <div id="page-content-wrapper">
                    <div className="container-fluid">
                        <button className="btn btn-link mt-3" id="menu-toggle"><FontAwesomeIcon icon={faList} /></button>


                        <div className="row">
                            <div className="col-md-6">
                                <h4 className="mt-2 man_hadding mb-3">Pair Management </h4>
                            </div>

                            <div className="col-md-6">
                                {stateType.map((val, i) =>
                                    <button className={"btn tab_btn " + (val.value == state.selected ? "active" : "") + " mb-3 mr-2"} onClick={() => typeChange(val, i)}> {val.name}
                                    </button>)}
                            </div>
                        </div>
                        <div className="white_box">
                            <button className="btn btn-primary ml-auto d-block  float-md-right mb-3 mr-2" data-toggle="modal" data-target="#add-user-modal"><FontAwesomeIcon icon={faPlus} /> Add </button>

                            <ReactDatatable
                                config={config}
                                records={records}
                                columns={columns}
                                onPageChange={pageChange}
                            />
                        </div>
                    </div>
                </div>
                <ToastContainer />
            </div>
        </div>
    );
}

Pair.propTypes = {
    auth: PropTypes.object.isRequired,
    pairdata: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
    auth: state.auth,
    pairdata: state.pairdata,
    records: state.records
});

export default connect(
    mapStateToProps
)(Pair);
